import React from 'react'
import clsx from 'clsx'

import styles from '@/css/home.module.css'
import public_styles from '@/css/public.module.css'

const Roadmap = () => {
  return (
    <section className={clsx(public_styles.block, public_styles.pt_0)}>
      <div className={clsx(public_styles.relative, public_styles.container)}>
        <div className={clsx(public_styles.h2, styles.cols__title)}>Roadmap</div>
        <div className={clsx(styles.roadmap, public_styles.mb_sm)}>
          <div className={styles.roadmap__section}>
            <p className={clsx(styles.roadmap__list_item, styles.empty)}>Contest announcement</p>
            <p className={clsx(styles.roadmap__list_item, styles.empty)}>
              Create strategy and roadmap of the Demo NFT project + Blockchain
            </p>
            <p className={clsx(styles.roadmap__list_item, styles.empty)}>Launch the website</p>
          </div>
          <div className={styles.roadmap__section}>
            <p className={clsx(styles.roadmap__list_item, styles.empty)}>
              Create The Demo NFT Collection: 100 unique NFTs
            </p>
            <p className={styles.roadmap__list_item}>Launch public sale of The Demo NFT Collection</p>
          </div>
          <div className={styles.roadmap__section}>
            <p className={styles.roadmap__list_item}>Launch The Demo DAO</p>
          </div>
          <div className={styles.roadmap__section}>
            <p className={styles.roadmap__list_item}>Land presale in The Demo Metaverse</p>
            <p className={styles.roadmap__list_item}>Create DAO for landowners</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Roadmap
